import axios from 'axios';
import { isStageEnvironment } from 'utils/environment';
import { OrderDistribution } from 'views/order-feed/features/order-distribution/types/order-distribution.type';
import OrderDistributionData from '../mock/order-distribution-data.mock';

// GET
export const getOrderDistributions = async (customerNumber: string): Promise<OrderDistribution[]> => {
  if (isStageEnvironment) return OrderDistributionData;

  const res = await axios.get(`/ewosapi/v1/order-distribution/customer/${customerNumber}`);
  return res.data;
};

export const getOrderDistribution = async (customerNumber: string, distributionId: string): Promise<OrderDistribution> => {
  if (isStageEnvironment) {
    const distribution = OrderDistributionData.find((item) => item.id === distributionId);
    if (distribution) return distribution;
  }

  const res = await axios.get(`/ewosapi/v1/order-distribution/customer/${customerNumber}/${distributionId}`);
  return res.data;
};
